import React from 'react';

interface ErrorMessageProps {
  message: string;
  onDismiss: () => void;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  onDismiss,
}) => {
  return (
    <div className="animate-fade-in fixed top-4 right-4 z-50 flex items-center space-x-4 rounded-lg bg-red-50 px-6 py-3 text-white shadow-lg dark:bg-red-950">
      <span className="text-xl leading-tight">⚠️</span>
      <span>{message}</span>
      <button
        onClick={onDismiss}
        className="ml-2 text-white hover:text-red-100"
      >
        ✕
      </button>
    </div>
  );
};
